export enum Sizes {
  medium = 'medium',
  small = 'small',
}
